import type { RouteRecordRaw } from 'vue-router';
import { RouterView } from 'vue-router';

const routes: RouteRecordRaw = {
  name: 'TeachingPractice',
  path: 'teaching_practice',
  redirect: { name: 'TeachingPracticeStudent' },
  component: RouterView,
  children: [
    {
      name: 'TeachingPracticeManage',
      path: 'manage',
      component: () => import('pages/teachingPractice/ManageLayout.vue'),
      meta: {
        authz: ({ roles }) => roles['ROLE_TP_MANAGER'],
      },
      children: [
        {
          name: 'TeachingPracticeManageList',
          path: '',
          component: () => import('pages/teachingPractice/manage/ListPage.vue'),
        },
        {
          name: 'TeachingPracticeManageCreate',
          path: 'create',
          component: () =>
            import('pages/teachingPractice/manage/CreatePage.vue'),
        },
        {
          name: 'TeachingPracticeManageImport',
          path: 'import',
          component: () =>
            import('pages/teachingPractice/manage/ImportPage.vue'),
        },
        {
          name: 'TeachingPracticeManageSupervisorList',
          path: 'supervisor_list',
          redirect: { name: 'TeachingPracticeManageSupervisorListUser' },
          component: () =>
            import('pages/teachingPractice/manage/SupervisorListLayout.vue'),
          children: [
            {
              name: 'TeachingPracticeManageSupervisorListUser',
              path: 'user',
              component: () =>
                import(
                  'pages/teachingPractice/manage/supervisorList/UserListPage.vue'
                ),
            },
            {
              name: 'TeachingPracticeManageSupervisorListExternalUser',
              path: 'external_user',
              component: () =>
                import(
                  'pages/teachingPractice/manage/supervisorList/ExternalUserListPage.vue'
                ),
            },
            {
              name: 'TeachingPracticeManageSupervisorAdd',
              path: 'add',
              component: () =>
                import(
                  'pages/teachingPractice/manage/supervisorList/UserAddPage.vue'
                ),
            },
            {
              name: 'TeachingPracticeManageSupervisorAddExternal',
              path: 'add_external',
              component: () =>
                import(
                  'pages/teachingPractice/manage/supervisorList/ExternalUserAddPage.vue'
                ),
            },
          ],
        },
        {
          name: 'TeachingPracticeManageShow',
          path: ':teachingPracticeId',
          component: () => import('pages/teachingPractice/manage/ShowPage.vue'),
        },
      ],
    },
    {
      name: 'TeachingPracticeSupervisor',
      path: 'supervisor',
      component: () => import('pages/teachingPractice/SupervisorPage.vue'),
      redirect: { name: 'TeachingPracticeSupervisorList' },
      children: [
        {
          path: '',
          name: 'TeachingPracticeSupervisorList',
          component: () =>
            import('pages/teachingPractice/supervisor/ListPage.vue'),
        },
        {
          path: ':id',
          name: 'TeachingPracticeSupervisorShow',
          redirect: {
            name: 'TeachingPracticeSupervisorShowStudent',
          },
          component: () =>
            import('pages/teachingPractice/supervisor/ShowPage.vue'),
          children: [
            {
              name: 'TeachingPracticeSupervisorShowStudent',
              path: 'student',
              component: () =>
                import('pages/teachingPractice/supervisor/ShowStudentPage.vue'),
            },
            {
              name: 'TeachingPracticeSupervisorShowMeeting',
              path: 'meeting',
              component: () =>
                import('pages/teachingPractice/supervisor/ShowMeetingPage.vue'),
            },
            {
              name: 'TeachingPracticeSupervisorShowEvaluationGrade',
              path: 'evaluation_grade',
              component: () =>
                import(
                  'pages/teachingPractice/supervisor/ShowEvaluationGradePage.vue'
                ),
            },
          ],
        },
      ],
    },
    {
      name: 'TeachingPracticeStudent',
      path: 'my',
      component: () => import('pages/teachingPractice/StudentPage.vue'),
      children: [
        {
          name: 'TeachingPracticeStudentShow',
          path: ':id',
          redirect: {
            name: 'TeachingPracticeStudentShowOverview',
          },
          component: () => import('pages/teachingPractice/StudentShowPage.vue'),
          children: [
            {
              name: 'TeachingPracticeStudentShowOverview',
              path: 'overview',
              component: () =>
                import('pages/teachingPractice/StudentShowOverviewPage.vue'),
            },
            {
              name: 'TeachingPracticeStudentShowSupervisor',
              path: 'supervisor',
              component: () =>
                import('pages/teachingPractice/StudentShowSupervisorPage.vue'),
            },
            {
              name: 'TeachingPracticeStudentShowTimeLog',
              path: 'time_log',
              component: () =>
                import('pages/teachingPractice/StudentShowTimeLogPage.vue'),
            },
            {
              name: 'TeachingPracticeStudentShowMeeting',
              path: 'meeting',
              component: () =>
                import('pages/teachingPractice/StudentShowMeetingPage.vue'),
            },
            {
              name: 'TeachingPracticeStudentShowEvaluationGrade',
              path: 'evaluation_grade',
              component: () =>
                import(
                  'pages/teachingPractice/StudentShowEvaluationGradeNewPage.vue'
                ),
            },
            {
              name: 'TeachingPracticeStudentShowEvaluationGradeNew',
              path: 'evaluation_grade_new',
              component: () =>
                import(
                  'pages/teachingPractice/StudentShowEvaluationGradePage.vue'
                ),
            },
          ],
        },
      ],
    },
    {
      name: 'TeachingPracticeShow',
      path: 'supervisor/:id',
      component: () => import('pages/teachingPractice/SupervisorShowPage.vue'),
    },
  ],
};

export const teachingPracticeRoutes = routes;
